// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0b0d4b41","74":"b8806ce7","182":"792cb9d6","292":"b082b520","321":"29d9d252","498":"91f30ce0","549":"ec0903c0","551":"f88aa810","760":"d7c44179","770":"bd6373af","815":"c6c8b5ad","842":"410afaa6","950":"e8422ebc"}[chunkId] + ".chunk.js";
};